import { Component, Inject, OnInit } from "@angular/core";
import { UntypedFormControl, UntypedFormGroup, Validators } from "@angular/forms";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { ISelectItems } from "@shared/models/selectItems";
import { SharedService } from "@shared/services/shared.service";
import { ICorrespondenceLetterTemplate, INewCorrespondenceViewModel } from "app/models/correspondence/correspondence";

import { ComplaintService } from "app/services/complaint/complaint.service";

@Component({
  selector: 'newCorrespondence',
  styleUrls: ['./newCorrespondence.component.scss'],
  templateUrl: './newCorrespondence.component.html',
})

export class NewCorrespondenceComponent implements OnInit {


  complaintId: number = 0;
  businessId: number = 0;
  id: number = 0;

  saveFlag: boolean = false;
  // typeList: ISelectItems[] = [];
  typeList: ICorrespondenceLetterTemplate[] = [];
  saved: boolean = false;
  businessOnly: boolean = false;
  letterBody: string = '';

  form = new UntypedFormGroup({
    correspondenceType: new UntypedFormControl('', [Validators.required]),
    title: new UntypedFormControl('', [Validators.required]),
  });

  constructor(
    private sharedService: SharedService,
    private complaintService: ComplaintService,
    private dialogRef: MatDialogRef<NewCorrespondenceComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.complaintId = this.data.complaintId;
    this.businessId = this.data.businessId;
    this.businessOnly = this.data.businessOnly;
    this.id = this.businessOnly ? this.businessId : this.complaintId;
  }

  ngOnInit(): void {
    this.getTemplate(0, this.id);
  }

  getTemplate(id: number, templateId: number): void {
    this.complaintService.getLetterTemplate(id, templateId, true, this.businessOnly).subscribe(
      (result) => {
        this.typeList = result;
      },
      error => {
        this.sharedService.toastr.error("Could not save file: " + error.message);
      }
    );
  }

  saveCorrespondence(){

    let saveData: INewCorrespondenceViewModel = {
      complaintId: this.complaintId,
      businessId: this.businessId,
      title: this.form.controls['title'].value,
      correspondeceTypeId: this.form.controls['correspondenceType'].value,
      body: this.letterBody,
      invalidAddress: false
    };

    this.complaintService.saveCorrespondenceLetter(saveData).subscribe(
      (result) => {
        this.sharedService.toastr.success("Letter Saved Successfully");
        this.saved = true;
        this.return();
      },
      error => {
        this.sharedService.toastr.error("Could not save letter: " + error.message);
      }
    );
  }

  checkNew()
  {
    if (this.form.controls['correspondenceType'].value != 0 &&
      this.form.controls['title'].value != '') {
        this.letterBody = this.typeList.find(x => x.letterTemplateId == this.form.controls['correspondenceType'].value).text;
      this.saveFlag = true;
      return;
    }
  }

  return(): void {
    let returnData = this.saved ? 'saved' : 'cancel';
    this.dialogRef.close(returnData);
  }
}